module.exports = __webpack_public_path__ + "img/offer2.05127b8d.png";